import { createAnnualMetricTable } from '../common/annualMetricTable';
export var HiringAheadTable = createAnnualMetricTable({
    metricKey: 'hiringAhead',
    titleKey: 'reportRows.hiringAhead',
    totalLabelKey: 'totalHiringAhead',
    unitKey: 'cost',
});
